import React from 'react';
import { useParams } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { Spinner } from 'equasion-lib';
import ApiError from '@/lib/shared-coms/ApiError';
import { useRootStore } from '@/lib/providers/RootProvider';
import { SALES_ORDER_PACKAGES, UPDATE_SHIP_PACKAGES } from '@/lib/shipPackages';
import SalesOrderPackages from './SalesOrderPackages';

/** Box Sizes: correct the box size of a shipped order's packages (`/sales-order-packages/:id`). */
const SalesOrderPackagesData = () => {
  const { id } = useParams();
  const vendorId = useRootStore((state) => state.selectedCompany.id) as string;
  const { data, error, loading, refetch } = useQuery(SALES_ORDER_PACKAGES, {
    variables: { id, vendorId },
    fetchPolicy: 'network-only',
    skip: !id || !vendorId
  });
  const [updatePackages] = useMutation(UPDATE_SHIP_PACKAGES);

  if (loading && !data) return <Spinner />;
  if (error && !data) return <ApiError error={error} />;

  return (
    <SalesOrderPackages
      salesOrder={data?.salesOrder}
      shippingDimensionOptions={data?.company?.integrationSettings?.shippingDimensionOptions || []}
      // No client-side permission gate, like the other post-ship actions: the server's
      // `sales-orders:fulfill` (→ `sales-orders:update`) refusal is shown if the user lacks it.
      save={(variables) => updatePackages({ variables: { ...variables, orderId: id, companyId: vendorId } })}
      reload={() => refetch()}
    />
  );
};

export default SalesOrderPackagesData;
